import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ResponseModel } from "src/app/models/response.model";
import { environment } from "src/environments/environment";
import { LoginResponseModel } from "../models/login-response.model";
import { LoginModel } from "../models/login.model";
import { catchError, map } from "rxjs/operators";

@Injectable()
export class LoginService {
    apiUrl: string;

    /**
     *
     */
    constructor(private http: HttpClient) {
        this.apiUrl = environment.apiUrl;
    }
    login(login: LoginModel): Observable<ResponseModel> {
        var result = this.http.post<ResponseModel>(this.apiUrl+'autenticacao/login', login)
        .pipe(
            map(response=>{return new ResponseModel(response)})
        );
        return result;
    }

}